import { Box, Link, Typography } from '@mui/material'
import type { FC } from 'react'
import './Contact.css'

interface MailLinkProps {
  readonly variant?: 'lessons' | 'gig' | 'collaboration' | 'tutor'
}

const MailLink: FC<MailLinkProps> = ({ variant }) => {
  let href = ''
  let text = ''

  switch (variant) {
    case 'lessons':
      href = 'mailto:catherinecwhall+lessons@gmail.com?subject=Lessons&body=Hello, Catherine!'
      text = 'violin lessons'
      break
    case 'gig':
      text = 'performance'
      href =
        'mailto:catherinecwhall+performance@gmail.com?subject=Performance&body=Hello, Catherine!'
      break
    case 'collaboration':
      text = 'music-making'
      href = 'mailto:catherinecwhall+collab@gmail.com?subject=Collaboration&body=Hello, Catherine!'
      break
    case 'tutor':
      text = 'tutoring'
      href = 'mailto:catherinecwhall+tutor@gmail.com?subject=Tutor&body=Hello, Catherine!'
      break
    default:
      text = 'catherinecwhall@gmail.com'
      href = 'mailto:catherinecwhall@gmail.com?body=Hello, Catherine!'
  }

  return (
    <Link
      href={href}
      className='hover-underline-animation'
      underline='none'
      sx={{ color: 'primary.main' }}
    >
      {text}
    </Link>
  )
}

const Contact = () => {
  return (
    <Box className='contact-page'>
      <Box id='image-c' component='aside' aria-hidden='true' />
      <Box className='contact-panel'>
        <Typography className='contact-heading' component='h1'>
          Let&apos;s Connect
        </Typography>
        <Typography className='contact-lead' component='p'>
          Interested in working together? Reach out for any of the following — I&apos;d love to hear
          from you.
        </Typography>
        <Box className='contact-options' component='ul'>
          <Box component='li' className='contact-option'>
            <Typography className='contact-option__label' component='span'>
              Lessons
            </Typography>
            <MailLink variant='lessons' />
          </Box>
          <Box component='li' className='contact-option'>
            <Typography className='contact-option__label' component='span'>
              Performance
            </Typography>
            <MailLink variant='gig' />
          </Box>
          <Box component='li' className='contact-option'>
            <Typography className='contact-option__label' component='span'>
              Tutoring
            </Typography>
            <MailLink variant='tutor' />
          </Box>
          <Box component='li' className='contact-option'>
            <Typography className='contact-option__label' component='span'>
              Collaboration
            </Typography>
            <MailLink variant='collaboration' />
          </Box>
        </Box>
        <Typography className='contact-general' component='p'>
          General inquiries: <MailLink />
        </Typography>
      </Box>
    </Box>
  )
}

export default Contact
